import { render, staticRenderFns } from "./AppendixAction.vue?vue&type=template&id=3b146bfb&scoped=true"
import script from "./AppendixAction.vue?vue&type=script&lang=js"
export * from "./AppendixAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b146bfb",
  null
  
)

export default component.exports